import sendMessageToNativeContainer from '@/mobile/native-container-app/send-message';
import React from 'react';
import { useTranslation } from 'react-i18next';

const { Customer } = Mobi2Go;

let showLoadingSpinner = () => {};

let hideLoadingSpinner = () => {};

export const setShowLoadingSpinner = showSpinnerFunction => {
    showLoadingSpinner = () => {
        try {
            showSpinnerFunction();
        } catch (e) {
            console.log('show spinner error', e);
        }
    };
};

export const setHideLoadingSpinner = hideSpinnerFunction => {
    hideLoadingSpinner = () => {
        try {
            hideSpinnerFunction();
        } catch (e) {
            console.log('hide spinner error', e);
        }
    };
};

export const FacebookButton = () => {
    const { t } = useTranslation('social-sign-in');
    return (
        <button
            className="m2g-button-facebook-login"
            onClick={() => {
                showLoadingSpinner();

                if (
                    Mobi2Go.app.platform === 'ios' ||
                    Mobi2Go.app.platform === 'android'
                ) {
                    sendMessageToNativeContainer('facebookLogin', null);
                } else {
                    window.FB &&
                        window.FB.login(
                            function(response) {
                                if (response.status === 'connected') {
                                    // Logged into your webpage and Facebook
                                    decideWhatToDoWithFacebookAuthentication(
                                        response.authResponse
                                    );
                                } else {
                                    // Not logged into your webpage or we are unable to tell.
                                    hideLoadingSpinner();
                                }
                            },
                            { scope: 'email,public_profile' }
                        );
                }
            }}
        >
            <div className="m2g-button-facebook-login-icon m2g-icon m2g-icon--facebook"></div>
            <div className="m2g-button-facebook-login-text">
                {t('sign_in_facebook')}
            </div>
        </button>
    );
};

export const setupFacebook = () => {
    window.fbAsyncInit = function() {
        window.FB &&
            window.FB.init({
                appId: Mobi2Go.headoffice.facebook_app_id,
                cookie: true,
                xfbml: false,
                version: 'v13.0',
            });
    };

    window.statusChangeCallback = response => {
        // Called with the results from FB.getLoginStatus().
        // console.log('statusChangeCallback');
        // console.log(response); // The current login status of the person.
        if (response.status === 'connected') {
            showLoadingSpinner();

            // Logged into your webpage and Facebook
            decideWhatToDoWithFacebookAuthentication(response.authResponse);
        } else {
            // Not logged into your webpage or we are unable to tell.
        }
    };

    window.checkLoginState = () => {
        // Called when a person is finished with the Login Button.
        window.FB &&
            window.FB.getLoginStatus(function(response) {
                // See the onlogin handler
                statusChangeCallback(response);
            });
    };

    window.nativeAppFacebookLogin = async data => {
        const {
            customer_data: { email, name },
            facebook_data: { facebookUserId, facebookAccessToken },
        } = data;

        const { is_registered: exists } = await checkIfAccountExists(email);

        if (exists) {
            try {
                Customer.logInWithFacebook(data);
            } catch (error) {
                hideLoadingSpinner();
            }
        } else {
            const registerData = {
                customer_data: {
                    email,
                    name,
                    is_subscriber: false,
                    facebook_user_id: facebookUserId,
                },
                facebook_data: {
                    facebookUserId,
                    facebookAccessToken,
                },
            };

            try {
                Customer.createAccountWithFacebook(registerData);
            } catch (error) {
                hideLoadingSpinner();
            }
        }
    };
};

export const AppleButton = () => {
    const { t } = useTranslation('social-sign-in');

    return (
        <button
            className="m2g-button-apple-login"
            onClick={() => {
                showLoadingSpinner();
                if (Mobi2Go.app.platform === 'android') {
                    sendMessageToNativeContainer('appleLogin', null);
                } else {
                    window.AppleID && window.AppleID.auth.signIn();
                }
            }}
        >
            <div className="m2g-button-apple-login-icon m2g-icon m2g-icon--apple"></div>
            <div className="m2g-button-apple-login-text">
                {t('sign_in_apple')}
            </div>
        </button>
    );
};

export const setupApple = () => {
    window.document.addEventListener('AppleIDSignInOnSuccess', data => {
        //handle successful response
        showLoadingSpinner();
        const { detail } = data;
        decideWhatToDoWithAppleAuthentication(detail);
    });

    window.document.addEventListener('AppleIDSignInOnFailure', error => {
        //handle error.
        Mobi2Go.log('Apple Sign In Failure', error);
        hideLoadingSpinner();
    });

    window.nativeAppAppleLogin = async data => {
        decideWhatToDoWithAppleAuthentication(data);
    };
};

const decideWhatToDoWithFacebookAuthentication = authResponse => {
    if (!Customer.isLoggedIn()) {
        window.FB &&
            window.FB.api(
                '/me',
                { fields: ['name', 'email'] },
                async facebookAccount => {
                    const {
                        is_registered: exists,
                        authentication_method,
                    } = await checkIfAccountExists(facebookAccount.email);

                    if (exists) {
                        logInWithFacebookMethod(authResponse, facebookAccount);
                    } else {
                        createAccountWithFacebook(
                            authResponse,
                            facebookAccount
                        );
                    }
                }
            );
    }
};

const checkIfAccountExists = email => {
    // Check if email is registered and if it's associated with a facebok account
    return new Promise(resolve => {
        Customer.isEmailRegistered(
            email,
            (is_registered, authentication_method) => {
                resolve({ is_registered, authentication_method });
            }
        );
    });
};

const logInWithFacebookMethod = (authResponse, facebookResponse) => {
    const { userID, accessToken } = authResponse;
    const { email } = facebookResponse;

    const data = {
        customer_data: {
            email,
        },
        facebook_data: {
            facebookUserId: userID,
            facebookAccessToken: accessToken,
        },
    };

    try {
        Customer.logInWithFacebook(data);
    } catch (error) {
        hideLoadingSpinner();
    }
};

const createAccountWithFacebook = (authResponse, facebookResponse) => {
    const { userID, accessToken } = authResponse;
    const { email, name } = facebookResponse;

    const data = {
        customer_data: {
            email,
            name,
            is_subscriber: false,
            facebook_user_id: userID,
        },
        facebook_data: {
            facebookUserId: userID,
            facebookAccessToken: accessToken,
        },
    };

    try {
        Customer.createAccountWithFacebook(data);
    } catch (error) {
        hideLoadingSpinner();
    }
};

const decideWhatToDoWithAppleAuthentication = async authResponse => {
    const { authorization, user } = authResponse;

    if (!Customer.isLoggedIn()) {
        // If there is no user, then this apple id has authenticated with us before
        if (!user) {
            logInWithAppleMethod(authorization);
        } else {
            // const {
            //     is_registered: exists,
            //     authentication_method,
            // } = await this.checkIfAccountExists(user.email);

            // if (exists) {
            //     if (!authentication_method.apple_sign_in) {
            //         if (authentication_method.facebook_sign_in) {
            //             this.warnForIncorrectLoginMethod('Facebook');
            //         } else {
            //             this.warnForIncorrectLoginMethod('password');
            //         }
            //     }
            // } else {

            createAccountWithApple(authResponse);
            // }
        }
    }
};

const logInWithAppleMethod = authorization => {
    try {
        Customer.logInWithApple(authorization);
    } catch (error) {
        hideLoadingSpinner();
    }
};

const createAccountWithApple = authResponse => {
    try {
        const { authorization, user } = authResponse;

        const { id_token, code } = authorization;
        const { email, name } = user;

        const data = {
            customer_data: {
                email,
                name: `${name.firstName} ${name.lastName}`,
                is_subscriber: false,
            },
            apple_data: {
                id_token,
                code,
            },
        };

        Customer.createAccountWithApple(data);
    } catch (error) {
        hideLoadingSpinner();
    }
};
